"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainNav_1 = require("./MainNav");
exports.MainNav = MainNav_1.MainNav;



//////////////////
// WEBPACK FOOTER
// ./src/components/MainNav/index.ts
// module id = 120
// module chunks = 0